/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { WorkflowService } from "../../services/workflow.service";

import { Workflow } from "../../models/workflow";
import { WorkflowNode, WorkflowNodeType } from "../../models/workflow-node";
import { WorkflowLogNode } from "../../models/workflow-log-node";
import { WorkflowLoopNode } from "../../models/workflow-loop-node";
import { WorkflowServiceNode } from "../../models/workflow-service-node";

@Component({
  selector: 'app-workflow',
  templateUrl: './workflow.component.html'
})
export class WorkflowComponent implements OnInit {

    workflow: Workflow;
    workflowNodes: WorkflowNode[];
    
    constructor(private route: ActivatedRoute) { }
    
    ngOnInit() {
        this.route.data.subscribe((data: { workflow: Workflow }) => {
            console.log("Editing Workflow: " + data.workflow);
            
            this.workflow = data.workflow;
            if (this.workflow.startNode != null) {
                let currentNode = this.createDerivedNode(this.workflow.startNode);
                this.workflowNodes = [];
                this.workflowNodes.push(currentNode);
                
                while (currentNode.nextNode != null) {
                    currentNode = this.createDerivedNode(currentNode.nextNode);
                    this.workflowNodes.push(currentNode);
                }
                
//                let workflowNode = WorkflowNode.toInstance(new WorkflowServiceNode(), this.workflow.startNode);
//                console.log("Hell Yeah: " + workflowNode.nextNode.type);
//                this.createDerivedNode(this.workflow.startNode);
//                console.log("WTF");
//
//                let nextNode = this.workflow.startNode;
//                while (workflowNode.nextNode != null) {
//                    console.log("Adding: " + workflowNode.nextNode.name);
//                    this.workflowNodes.push(workflowNode.nextNode);
//                    workflowNode = workflowNode.nextNode;
//                }
            }
        });
    }

    getGlpyhForEvent(event: Event): string {
        return this.workflow.event.glyph == null || this.workflow.event.glyph.length == 0 ? "fa-users" : this.workflow.event.glyph;
    }
    
    private createDerivedNode(node: WorkflowNode): any {
        const nodeType = WorkflowNodeType[node.type];

        switch (nodeType) {
            case WorkflowNodeType.SERVICE:
                return WorkflowNode.toInstance(new WorkflowServiceNode(), node);
            case WorkflowNodeType.LOG:
                return WorkflowNode.toInstance(new WorkflowServiceNode(), node);
            case WorkflowNodeType.LOOP:
                return WorkflowNode.toInstance(new WorkflowLoopNode(), node);
        } 
    }
}
